import { getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackUserEvent } from '../analytics';
import type { ZrmClickstreamUser } from '@zg-rentals/clickstream';

// https://dataportal.zillowgroup.net/event-registry/3974
export const emitDeleteTaskFromTaskDetailPageEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '3974',
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'zrm_maintenance',
      trigger_source_nm: 'yes_delete',
      trigger_object_nm: 'task_detail_page',
    },
    semantic: {
      semantic_event_nm: 'zrm_maintenance',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3975
export const emitDeleteTaskFromTaskTableEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '3975',
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'zrm_maintenance',
      trigger_source_nm: 'yes_delete',
      trigger_object_nm: 'task_list_page',
    },
    semantic: {
      semantic_event_nm: 'zrm_maintenance',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });
